import { useUserStore } from '@bv/stores';

import type { UpdateUserStatusType } from '@/types/events/update-user-status';
import { UserStatus } from '@/types/user';

import { useRealtimeUserStatusStore } from '../../../stores/realtime-user-status.store';

export default function updateUserStatus({ data }: { data: UpdateUserStatusType }): void {
  const detailsStore = useUserStore();
  const realtimeStatusStore = useRealtimeUserStatusStore();

  // Realtime status update for ANY user (used by dashboard lists)
  realtimeStatusStore.upsert(data.userId, {
    status: data.status as UserStatus,
    lastStatusChangedAt: data.lastStatusChangedAt,
  });

  realtimeStatusStore.changeActiveUsersRefetchKey();

  if (detailsStore.userDetails && detailsStore.userDetails.id === data.userId) {
    detailsStore.updateUserStatus(data.status as UserStatus);
  }
}
